import React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { categoriesMapper, filesMapper, organismeMapper } from './mapper';
import ListItems from './listItems';
import ComplementInputs from './complementInputs';
import UploadFiles from './uploadFiles';
import Recap from './Recap';

const ActiveStep = ({ activeStep }: any) => {
  const intl = useIntl();
  const pacOrganismes = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'pacOrganismes']),
  );
  const pacCategories = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'pacCategories']),
  );
  const pacObject = useSelector((state: RootStateOrAny) =>
    state.getIn(['pac', 'pacObject']),
  );

  const schoolCertifFile = {
    Id: '001',
    LibellePiece: 'Une copie de certificat de scolarité',
  };

  /* istanbul ignore next */
  const calculateAge = (dateNaissance: any) => {
    return Math.abs(
      moment().diff(moment(dateNaissance, 'DD/MM/YYYY', true), 'years'),
    );
  };

  /* istanbul ignore next */
  const shouldAddschoolCertif = (chosedCategory: any) => {
    return (
      chosedCategory?.Libelle.toLowerCase() === 'enfant' &&
      calculateAge(pacObject.DateNaissanceFormatted) >= 21
    );
  };

  /* istanbul ignore next */
  const getDocumentsOfCategory = (categoryId: string) => {
    const chosedCategory = pacCategories?.find(
      (elem: { Id: string }) => elem.Id === categoryId,
    );
    const listePieces = chosedCategory ? chosedCategory.ListePieces : [];
    if (shouldAddschoolCertif(chosedCategory))
      listePieces.push(schoolCertifFile);

    // remove duplicated object from list docs
    return Array.from(new Set(listePieces.map((file: any) => file.Id))).map(
      (id) => {
        return listePieces.find((file: any) => file.Id === id);
      },
    );
  };
  return (
    <>
      {(() => {
        switch (activeStep) {
          case 0:
            return (
              <ListItems
                listItems={organismeMapper(pacOrganismes ? pacOrganismes : [])}
                titleCard={intl.formatMessage({
                  id: 'Home_text_Health_select_organisme',
                })}
                activeStep={activeStep}
                radioButtonName="organisme"
              />
            );
          case 1:
            return (
              <ListItems
                listItems={categoriesMapper(pacCategories ? pacCategories : [])}
                titleCard={intl.formatMessage({
                  id: 'Home_text_Health_declarer_une_personne_step1Title',
                })}
                activeStep={activeStep}
                radioButtonName="category"
              />
            );

          case 2:
            return <ComplementInputs />;

          case 3:
            return (
              <UploadFiles
                title={intl.formatMessage({
                  id: 'documentsStepTitle',
                })}
                items={filesMapper(
                  getDocumentsOfCategory(pacObject.category?.id),
                )}
                filesLimit={10}
              />
            );

          case 4:
            return <Recap />;
          default:
            return null;
        }
      })()}
    </>
  );
};
export default ActiveStep;
